import { tokens } from 'styling/tokens'

export const zoneLevels = [
  { label: 'Zone', value: 1 },
  { label: 'Section', value: 2 },
  { label: 'Block', value: 3 },
  { label: 'Pit', value: 4 },
]

export const priorityOptions = [
  { label: 'Low', value: 1 },
  { label: 'Medium', value: 2 },
  { label: 'High', value: 3 },
  { label: 'Critical', value: 4 },
]

export const boardVisibilityOptions = [
  { label: 'Internal (team)', value: 1 },
  { label: 'Ops directors', value: 2 },
  { label: 'Executive', value: 3 },
]

export const horizonTypeOptions = [
  { label: 'Next Hours', value: 1 },
  { label: 'Next Shift', value: 2 },
]

export const planStatuses = [
  { label: 'Draft', value: 1, color: tokens.text.muted, tone: 'neutral' as const },
  { label: 'Active', value: 2, color: tokens.status.success.fg, tone: 'success' as const },
  { label: 'Paused', value: 3, color: tokens.status.warning.fg, tone: 'warning' as const },
  { label: 'Completed', value: 4, color: tokens.status.success.fg, tone: 'success' as const },
  { label: 'Cancelled', value: 5, color: tokens.status.danger.fg, tone: 'danger' as const },
]

export const executableTypeList = [
  { value: 1, label: 'Cycle' },
  { value: 2, label: 'Workflow' },
  { value: 3, label: 'Process' },
]

export const advanceRuleList = [
  { value: 1, label: 'Manual Gate' },
  { value: 2, label: 'Auto on completion' },
]

export const horizonList = [
  { value: 1, label: 'Horizon 1' },
  { value: 2, label: 'Horizon2' },
  { value: 3, label: 'Horizon 3' },
]

export const planPriorities = [
  { label: 'Low', value: 1 },
  { label: 'Medium', value: 2 },
  { label: 'High', value: 3 },
  { label: 'Critical', value: 4 },
]

export const STATUS_COLORS: Record<string, string> = {
  Active: tokens.status.success.fg,
  Paused: tokens.status.warning.fg,
  Completed: tokens.status.success.fg,
  Cancelled: tokens.status.danger.fg,
  Draft: tokens.text.muted,
}

// Draft = 1, Active = 2, Completed = 3, Skipped = 4

export const phaseStatuses = [
  { label: 'Draft', value: 1, color: tokens.text.muted },
  { label: 'Active', value: 2, color: tokens.status.success.fg },
  { label: 'Completed', value: 3, color: tokens.status.success.fg },
  { label: 'Skipped', value: 4, color: tokens.status.danger.fg },
]

export const workflowCriteriaList = [
  { label: 'Cheapest', value: 1 },
  { label: 'Soonest', value: 2 },
]

export const planAuditEventTypes = [
  { label: 'Created', value: 1, color: tokens.text.muted, tone: 'neutral' as const },
  { label: 'Updated', value: 2, color: tokens.status.info.fg, tone: 'info' as const },
  { label: 'Activated', value: 3, color: tokens.status.success.fg, tone: 'success' as const },
  { label: 'Paused', value: 4, color: tokens.status.warning.fg, tone: 'warning' as const },
  { label: 'Resumed', value: 5, color: tokens.status.success.fg, tone: 'success' as const },
  { label: 'Completed', value: 6, color: tokens.status.success.fg, tone: 'success' as const },
  { label: 'Cancelled', value: 7, color: tokens.status.danger.fg, tone: 'danger' as const },
]
